import { appFields } from './fields';
import { appStatus, statusesList } from './status';
import { getTextValue } from './utils';

export const getFieldName = (name: string) => getTextValue(name, appFields);
export const statusValue = statusesList;
export const getStatusName = (name: string) => getTextValue(name, appStatus);

export { fixValue, transformFields, transformWithObjectFields } from './utils';
